// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__31pjQ","dragIcon":"Choice_dragIcon__35W7F","left":"Choice_left__3cEMH","input":"Choice_input__3pbuu"};